module.exports = __webpack_public_path__ + "static/media/dark.ab4b3459.svg";